export const Config = {
    linkExplore: 'https://app.sprinta.com.br/explore',
    linkHome: 'https://app.sprinta.com.br/',
 }


// WEBPACK FOOTER //
// ./src/SPRINTA/Footer/_config.js